import groq from "groq"

export const complaintProjection = () => groq`
  ...,
  "id": _id,
  "rev": _rev,
  applications[]->{"id": _id, name, label},
  defects[]->{"id": _id, name, label},
  customerClaims[]->{"id": _id, name, label},
  attachmentReferences[]{"id": _key, name, size, asset, url, mimetype},
  creationBy->{"number": key, name},
  modifiedBy->{"number": key, name},
`

export const complaintProjectionForTable = () => groq`
  ...,
  "id": _id,
  "rev": _rev,
  defects[]->{"id": _id, label},
`
